import { Link } from 'react-router-dom'
import { Shield, Home, ArrowLeft } from 'lucide-react'

const Unauthorized = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto h-24 w-24 flex items-center justify-center rounded-full bg-red-100">
          <Shield className="h-12 w-12 text-red-600" />
        </div>
        
        <h1 className="mt-6 text-4xl font-bold text-gray-900">
          403
        </h1>
        
        <h2 className="mt-4 text-2xl font-semibold text-gray-700">
          Acesso Negado
        </h2>
        
        <p className="mt-4 text-gray-600">
          Você não tem permissão para acessar esta página. 
          Esta área é restrita para administradores.
        </p>
        
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            <Home className="h-4 w-4 mr-2" />
            Ir para Home
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Voltar
          </button>
        </div>
        
        <div className="mt-8 text-sm text-gray-500">
          <p>
            Se você acredita que deveria ter acesso a esta página, 
            entre em contato com o administrador do sistema.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Unauthorized
